import { CapacitorWifiConnect, ConnectState } from '@falconeta/capacitor-wifi-connect';

import { IS_IOS } from '../../../../../common/constants';
import { timeout } from '../../../../../utils/common/common-utils';
import { WAIT_FOR_NATIVE_WIFI_MS } from './constants';

type WifiDeviceConnectOptions = {
  ssid: string;
  password: string;
};

export async function connectToSelectedNetwork(currentSsid: string, homeSsid: string, password?: string) {
  const isOnHomeSsid = currentSsid === homeSsid;
  console.log('[Ayla Wi-Fi] Current / target SSID:', currentSsid, homeSsid);

  // Force connect only if not already on the desired home network.
  if (!isOnHomeSsid) {
    const attemptConnect = async () => {
      console.log('[Ayla Wi-Fi] Joining target network:', homeSsid);
      if (password) {
        const result = await CapacitorWifiConnect.secureConnect({
          ssid: homeSsid,
          password,
          saveNetwork: false,
        });
        console.log('[Ayla Wi-Fi] secureConnect result:', result?.value);
      } else {
        const result = await CapacitorWifiConnect.connect({ ssid: homeSsid });
        console.log('[Ayla Wi-Fi] connect result:', result?.value);
      }
    };

    try {
      await attemptConnect();
    } catch (e) {
      console.log('[Ayla Wi-Fi] Join rejected; checking SSID. Error code:', (e as { code?: number })?.code);
      // Verify current SSID.
      const current = await CapacitorWifiConnect.getDeviceSSID();
      const currentSsid = current?.value;
      console.log('[Ayla Wi-Fi] SSID after rejected join:', currentSsid, 'status:', current?.status);
      if (currentSsid !== homeSsid) {
        console.log('[Ayla Wi-Fi] Retrying join once');
        await attemptConnect();
      }
    }

    await timeout(3000);
    console.log('[Ayla Wi-Fi] Join settling delay completed');
  }
}

export async function connectToWifiDevice({ ssid, password }: WifiDeviceConnectOptions): Promise<ConnectState> {
  console.log('[Ayla Wi-Fi] Starting connection. iOS:', IS_IOS, 'target:', ssid);
  if (!IS_IOS) {
    const { value: connectState } = await CapacitorWifiConnect.secureConnect({ ssid, password });
    console.log('[Ayla Wi-Fi] Android secureConnect result:', connectState);
    if (connectState === ConnectState.Ok) {
      await timeout(WAIT_FOR_NATIVE_WIFI_MS);
    }
    return connectState;
  }

  const current = await CapacitorWifiConnect.getDeviceSSID();
  console.log('[Ayla Wi-Fi] Initial iOS SSID:', current?.value, 'status:', current?.status);
  await connectToSelectedNetwork(current?.value ?? '', ssid, password);

  return ConnectState.Ok;
}
